import React from "react";
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom'
import './App.css';
import RouterList from './router/index.js'
import { startPath } from '@/router/config'

function App () {
  const navigate = useNavigate();
  const token = localStorage.getItem('cruise_m350_isLogin');
  useEffect(() => {
    if (!token) {
      navigate(startPath, { replace: true })
    }
    //eslint-disable-next-line
  }, [token])
  return (
    <RouterList></RouterList>
  );
}

export default App;
